import { render, staticRenderFns } from "./zhaohuFooter.vue?vue&type=template&id=036924a0&scoped=true"
import script from "./zhaohuFooter.vue?vue&type=script&lang=js"
export * from "./zhaohuFooter.vue?vue&type=script&lang=js"
import style0 from "./zhaohuFooter.vue?vue&type=style&index=0&id=036924a0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036924a0",
  null
  
)

export default component.exports